import React, { useState, useMemo } from 'react';
import { Select } from 'antd';
import {
  ChevronLeft,
  ChevronRight,
  Calendar,
  Search,
  X,
  Clock,
  User,
  CheckCircle2,
  AlertCircle,
  AlertTriangle,
  Building2,
  DollarSign,
  Activity,
  FileText,
  Edit3,
  RefreshCw,
  ChevronDown,
  Users,
  TrendingUp
} from 'lucide-react';
interface BranchSelectProps {
  selectedBranch: string;
  setSelectedBranch: (value: string) => void;
}
interface ScheduleItem {
  id: string;
  name: string;
  service: string;
  timeInfo: string;
  statusText: string;
  statusType: 'warning' | 'error' | 'default';
  code: string;
  channel: 'Newhair' | 'Clinic' | 'PTTM' | 'Hậu phẫu' | string;
  expectedTime: string;
  status: string;
  consultant: string;
  price: string;
  deadline: string;
  checklist: string;
}

// 1. Dữ liệu danh sách Chờ xếp lịch (Cột bên trái)
const waitingListMock: ScheduleItem[] = [
  {
    id: 'w1',
    name: 'Tina Nguyen',
    service: 'Cấy tóc tự thân 1.200 nang – Newhair',
    timeInfo: '5h • Hạn 05/09 • 38 tr • hồ sơ 6/7',
    statusText: 'Tư vấn 28/8 đã chốt – chờ xếp lịch',
    statusType: 'warning',
    code: 'CX-117',
    channel: 'Newhair',
    expectedTime: 'Chưa xếp • dự kiến 5h',
    status: 'Chờ xếp',
    consultant: 'Phạm Ngọc Quang',
    price: '38.000.000 đ',
    deadline: '05/09',
    checklist: '6/7 • còn xác nhận giờ với khách'
  },
  {
    id: 'w2',
    name: 'Đặng T. Kim Chi',
    service: 'K-Lift Signature – buổi 1/6',
    timeInfo: '1h30 • Hạn 02/09 • 68 tr • 6/7',
    statusText: 'Thiếu xét nghiệm tiền phẫu',
    statusType: 'error',
    code: 'CX-118',
    channel: 'Clinic',
    expectedTime: 'Chưa xếp • dự kiến 1h30',
    status: 'Chờ xếp',
    consultant: 'Nguyễn Văn A',
    price: '68.000.000 đ',
    deadline: '02/09',
    checklist: '6/7 • thiếu xét nghiệm tiền phẫu'
  },
  {
    id: 'w3',
    name: 'Hoàng V. Nam',
    service: 'Cấy tóc HAT 2.000 nang',
    timeInfo: '5h30 • Hạn 05/09 • 96 tr • 7/10',
    statusText: 'Chưa đủ cọc – thiếu 19.200.000 đ',
    statusType: 'error',
    code: 'CX-119',
    channel: 'Newhair',
    expectedTime: 'Chưa xếp • dự kiến 5h30',
    status: 'Chờ xếp',
    consultant: 'Trần Thị B',
    price: '96.000.000 đ',
    deadline: '05/09',
    checklist: '7/10 • thiếu cọc'
  },
  {
    id: 'w4',
    name: 'Lý T. Thu',
    service: 'Nâng ngực túi Motiva',
    timeInfo: '3h • Hạn 08/09 • 120 tr • 9/12',
    statusText: 'Thiếu xét nghiệm tiền phẫu',
    statusType: 'error',
    code: 'CX-120',
    channel: 'PTTM',
    expectedTime: 'Chưa xếp • dự kiến 3h',
    status: 'Chờ xếp',
    consultant: 'Lê Văn C',
    price: '120.000.000 đ',
    deadline: '08/09',
    checklist: '9/12 • thiếu xét nghiệm'
  },
  {
    id: 'w5',
    name: 'Mai V. Tùng',
    service: 'K-Reshape Advanced – buổi 1/4',
    timeInfo: '1h • Hạn 31/08 • 34 tr • 7/7',
    statusText: 'Sẵn sàng xếp lịch',
    statusType: 'default',
    code: 'CX-121',
    channel: 'Clinic',
    expectedTime: 'Chưa xếp • dự kiến 1h',
    status: 'Chờ xếp',
    consultant: 'Phạm Ngọc Quang',
    price: '34.000.000 đ',
    deadline: '31/08',
    checklist: '7/7 • đủ điều kiện'
  }
];

const BRANCH_OPTIONS = [
  { value: 'Tất cả', label: 'Tất cả' },
  { value: 'Newhair', label: 'Newhair' },
  { value: 'Clinic', label: 'Clinic' },
  { value: 'PTTM', label: 'PTTM' },
  { value: 'Hậu phẫu', label: 'Hậu phẫu' },
];

// 2. Dữ liệu ảo cho TẤT CẢ các ca trên Timeline (Chế độ Ngày)
const timelineMockData: Record<string, ScheduleItem> = {
  maiAnh: {
    id: 't1',
    name: 'Nguyễn T. Mai Anh',
    service: 'Nâng mũi cấu trúc sụn sườn',
    timeInfo: '12/12',
    statusText: 'Đã xếp lịch',
    statusType: 'default',
    code: 'CX-105',
    channel: 'PTTM',
    expectedTime: '09:00 - 13:00',
    status: 'Đã xếp',
    consultant: 'BS. Long',
    price: '45.000.000 đ',
    deadline: '28/08',
    checklist: '12/12 • Đủ điều kiện'
  },
  doanYen: {
    id: 't2',
    name: 'Đoàn T. Yến',
    service: 'Cắt mí dưới',
    timeInfo: '12/12',
    statusText: 'Đã xác nhận',
    statusType: 'default',
    code: 'CX-106',
    channel: 'PTTM',
    expectedTime: '11:15 - 13:15',
    status: 'Đã xếp',
    consultant: 'BS. Hùng',
    price: '18.000.000 đ',
    deadline: '28/08',
    checklist: '12/12 • Đủ điều kiện'
  },
  tranHuy: {
    id: 't3',
    name: 'Trần Q. Huy',
    service: 'Cắt mí trên + treo cung mày',
    timeInfo: '11/12',
    statusText: 'Đã xếp lịch',
    statusType: 'default',
    code: 'CX-107',
    channel: 'PTTM',
    expectedTime: '14:30 - 17:00',
    status: 'Đã xếp',
    consultant: 'BS. Hùng',
    price: '25.000.000 đ',
    deadline: '28/08',
    checklist: '11/12 • Đủ điều kiện'
  },
  leDuc: {
    id: 't4',
    name: 'Lê V. Đức',
    service: 'Cấy tóc HAT 2.800 nang',
    timeInfo: '10/10',
    statusText: 'Đang thực hiện',
    statusType: 'default',
    code: 'CX-108',
    channel: 'Newhair',
    expectedTime: '10:00 - 15:00',
    status: 'Đang thực hiện',
    consultant: 'BS. Trâm',
    price: '85.000.000 đ',
    deadline: '28/08',
    checklist: '10/10 • Hoàn tất thủ tục'
  },
  ekip1: {
    id: 't5',
    name: 'Khoá ekip – TH-2603',
    service: 'Hỗ trợ ca Cấy tóc Lê V. Đức',
    timeInfo: 'Ekip 4 KTV',
    statusText: 'Đang thực hiện',
    statusType: 'default',
    code: 'TH-2603',
    channel: 'Newhair',
    expectedTime: '10:00 - 15:00',
    status: 'Khóa kíp',
    consultant: 'Ekip cấy tóc 1',
    price: '0 đ',
    deadline: '28/08',
    checklist: 'Đã phân công'
  },
  phamTuan: {
    id: 't6',
    name: 'Phạm A. Tuấn',
    service: 'Cấy tóc HAT 1.500 nang',
    timeInfo: '8/10',
    statusText: 'Đã xếp lịch',
    statusType: 'default',
    code: 'CX-109',
    channel: 'Newhair',
    expectedTime: '10:20 - 13:40',
    status: 'Đã xếp',
    consultant: 'BS. Khoa',
    price: '48.000.000 đ',
    deadline: '28/08',
    checklist: '8/10 • Đủ điều kiện'
  },
  buiDuy: {
    id: 't7',
    name: 'Bùi K. Duy',
    service: 'Cấy tóc HAT 1.200 nang',
    timeInfo: '9/10',
    statusText: 'Đã xếp lịch',
    statusType: 'default',
    code: 'CX-110',
    channel: 'Newhair',
    expectedTime: '14:15 - 17:30',
    status: 'Đã xếp',
    consultant: 'BS. Khoa',
    price: '39.000.000 đ',
    deadline: '28/08',
    checklist: '9/10 • Đủ điều kiện'
  },
  huanPhan: {
    id: 't8',
    name: 'Huan Phan',
    service: 'K-Lift Signature',
    timeInfo: '6/6',
    statusText: 'Hoàn tất',
    statusType: 'default',
    code: 'CX-111',
    channel: 'Clinic',
    expectedTime: '10:00 - 11:30',
    status: 'Hoàn tất',
    consultant: 'KTV Ngân',
    price: '15.000.000 đ',
    deadline: '28/08',
    checklist: '6/6 • Đủ điều kiện'
  },
  doHa: {
    id: 't9',
    name: 'Đỗ T. Hà',
    service: 'K-Reskin Advanced',
    timeInfo: '6/6',
    statusText: 'Đang thực hiện',
    statusType: 'default',
    code: 'CX-112',
    channel: 'Clinic',
    expectedTime: '11:30 - 13:00',
    status: 'Đang thực hiện',
    consultant: 'KTV Ngân',
    price: '12.000.000 đ',
    deadline: '28/08',
    checklist: '6/6 • Đủ điều kiện'
  },
  vuChau: {
    id: 't10',
    name: 'Vũ M. Châu',
    service: 'K-Lift Advanced 7/8',
    timeInfo: '7/8',
    statusText: 'Đã xếp lịch',
    statusType: 'default',
    code: 'CX-113',
    channel: 'Clinic',
    expectedTime: '14:30 - 16:30',
    status: 'Đã xếp',
    consultant: 'KTV Ngân',
    price: '18.000.000 đ',
    deadline: '28/08',
    checklist: '7/8 • Đủ điều kiện'
  },
  truongThao: {
    id: 't11',
    name: 'Trương M. Thảo',
    service: 'K-Renewal Laser',
    timeInfo: '5/5',
    statusText: 'Hoàn tất',
    statusType: 'default',
    code: 'CX-114',
    channel: 'Clinic',
    expectedTime: '10:00 - 11:30',
    status: 'Hoàn tất',
    consultant: 'KTV Vy',
    price: '8.000.000 đ',
    deadline: '28/08',
    checklist: '5/5 • Đủ điều kiện'
  },
  lamDuy: {
    id: 't12',
    name: 'Lâm T. Duy',
    service: 'K-Brighten Therapy',
    timeInfo: '6/6',
    statusText: 'Đang thực hiện',
    statusType: 'default',
    code: 'CX-115',
    channel: 'Clinic',
    expectedTime: '11:30 - 13:00',
    status: 'Đang thực hiện',
    consultant: 'KTV Vy',
    price: '9.500.000 đ',
    deadline: '28/08',
    checklist: '6/6 • Đủ điều kiện'
  },
  caoNam: {
    id: 't13',
    name: 'Cao V. Nam',
    service: 'K-Prime Laser 6/6',
    timeInfo: '6/6',
    statusText: 'Đã Check-in',
    statusType: 'default',
    code: 'CX-116',
    channel: 'Clinic',
    expectedTime: '14:15 - 15:45',
    status: 'Check-in',
    consultant: 'KTV Vy',
    price: '14.000.000 đ',
    deadline: '28/08',
    checklist: '6/6 • Đủ điều kiện'
  },
  ngoLoc: {
    id: 't14',
    name: 'Ngô T. Lộc',
    service: 'K-Brighten Laser 3/6',
    timeInfo: '3/6',
    statusText: 'Cảnh báo thiếu cọc',
    statusType: 'warning',
    code: 'CX-123',
    channel: 'Clinic',
    expectedTime: '16:00 - 17:30',
    status: 'Đã xếp',
    consultant: 'KTV Vy',
    price: '7.500.000 đ',
    deadline: '28/08',
    checklist: '3/6 • Chưa thanh toán đủ'
  },
  hoiTinhMaiAnh: {
    id: 't15',
    name: 'Hồi tỉnh – Mai Anh',
    service: 'Theo dõi sau mổ - Giường 1',
    timeInfo: '5/5',
    statusText: 'Đang theo dõi',
    statusType: 'default',
    code: 'CX-105-HT',
    channel: 'Hậu phẫu',
    expectedTime: '12:00 - 14:30',
    status: 'Đang hồi tỉnh',
    consultant: 'Điều dưỡng ca ngày',
    price: '0 đ',
    deadline: '28/08',
    checklist: '5/5 • Sinh hiệu ổn định'
  }
};

// 3. Dữ liệu Ma trận Chế độ Xem Tuần
interface WeekSlot {
  time: string;
  name: string;
  isHighlight?: boolean;
  colorType?: 'amber' | 'emerald' | 'blue' | 'teal' | 'red' | 'gray';
  itemRef?: ScheduleItem;
}

interface RoomWeekData {
  roomName: string;
  days: Record<string, { slots: WeekSlot[]; extraCount?: number }>;
}

const weekViewMockData: RoomWeekData[] = [
  {
    roomName: 'Phòng mổ 1',
    days: {
      T2: {
        slots: [
          { time: '08:00', name: 'Trần B. Ngọc', colorType: 'gray' },
          { time: '10:00', name: 'Lê H. Phúc', colorType: 'gray' }
        ]
      },
      T3: {
        slots: [
          { time: '08:00', name: 'Đỗ V. Minh', colorType: 'gray' },
          { time: '10:00', name: 'Ngô T. Hằng', colorType: 'gray' },
          { time: '12:00', name: 'Bùi Q. Đạt', colorType: 'gray' }
        ]
      },
      T4: {
        slots: [
          { time: '08:00', name: 'Võ T. Nhi', colorType: 'gray' },
          { time: '10:00', name: 'Đặng H. Long', colorType: 'gray' }
        ]
      },
      T5: {
        slots: [
          { time: '08:00', name: 'Hồ T. Vy', colorType: 'gray' },
          { time: '10:00', name: 'Dương K. Oanh', colorType: 'gray' },
          { time: '12:00', name: 'Phan V. Sơn', colorType: 'gray' }
        ]
      },
      T6: {
        slots: [
          { time: '08:00', name: 'Nguyễn T. Ma...', isHighlight: true, colorType: 'amber', itemRef: timelineMockData.maiAnh },
          { time: '13:00', name: 'Trần Q. Huy', isHighlight: true, colorType: 'amber', itemRef: timelineMockData.tranHuy }
        ]
      },
      T7: {
        slots: [{ time: '08:00', name: 'Nguyễn T. Ma...', isHighlight: true, colorType: 'amber' }]
      },
      CN: {
        slots: [
          { time: '08:00', name: 'Võ T. Nhi', colorType: 'gray' },
          { time: '10:00', name: 'Đặng H. Long', colorType: 'gray' }
        ]
      }
    }
  },
  {
    roomName: 'Phòng cấy tóc A',
    days: {
      T2: {
        slots: [
          { time: '09:00', name: 'Đặng H. Long', colorType: 'gray' },
          { time: '11:00', name: 'Lý M. Tâm', colorType: 'gray' },
          { time: '13:00', name: 'Hồ T. Vy', colorType: 'gray' }
        ],
        extraCount: 1
      },
      T3: {
        slots: [
          { time: '09:00', name: 'Dương K. Oanh', colorType: 'gray' },
          { time: '11:00', name: 'Phan V. Sơn', colorType: 'gray' },
          { time: '13:00', name: 'Trần B. Ngọc', colorType: 'gray' }
        ]
      },
      T4: {
        slots: [
          { time: '09:00', name: 'Lê H. Phúc', colorType: 'gray' },
          { time: '11:00', name: 'Phạm T. Quỳnh', colorType: 'gray' },
          { time: '13:00', name: 'Đỗ V. Minh', colorType: 'gray' }
        ],
        extraCount: 2
      },
      T5: {
        slots: [
          { time: '09:00', name: 'Ngô T. Hằng', colorType: 'gray' },
          { time: '11:00', name: 'Bùi Q. Đạt', colorType: 'gray' },
          { time: '13:00', name: 'Võ T. Nhi', colorType: 'gray' }
        ],
        extraCount: 1
      },
      T6: {
        slots: [
          { time: '08:30', name: 'Lê V. Đức', isHighlight: true, colorType: 'emerald', itemRef: timelineMockData.leDuc }
        ]
      },
      T7: {
        slots: [{ time: '08:30', name: 'Lê V. Đức', isHighlight: true, colorType: 'emerald' }]
      },
      CN: {
        slots: [
          { time: '09:00', name: 'Lê H. Phúc', colorType: 'gray' },
          { time: '11:00', name: 'Phạm T. Quỳnh', colorType: 'gray' }
        ]
      }
    }
  },
  {
    roomName: 'Phòng cấy tóc B',
    days: {
      T2: {
        slots: [
          { time: '10:00', name: 'Phạm T. Quỳnh', colorType: 'gray' },
          { time: '12:00', name: 'Đỗ V. Minh', colorType: 'gray' },
          { time: '14:00', name: 'Ngô T. Hằng', colorType: 'gray' }
        ]
      },
      T3: {
        slots: [
          { time: '10:00', name: 'Bùi Q. Đạt', colorType: 'gray' },
          { time: '12:00', name: 'Võ T. Nhi', colorType: 'gray' },
          { time: '14:00', name: 'Đặng H. Long', colorType: 'gray' }
        ],
        extraCount: 1
      },
      T4: {
        slots: [
          { time: '10:00', name: 'Lý M. Tâm', colorType: 'gray' },
          { time: '12:00', name: 'Hồ T. Vy', colorType: 'gray' },
          { time: '14:00', name: 'Dương K. Oanh', colorType: 'gray' }
        ]
      },
      T5: {
        slots: [
          { time: '08:00', name: 'Đỗ V. Minh', colorType: 'gray' },
          { time: '10:00', name: 'Phan V. Sơn', colorType: 'gray' },
          { time: '12:00', name: 'Trần B. Ngọc', colorType: 'gray' }
        ],
        extraCount: 2
      },
      T6: {
        slots: [
          { time: '09:00', name: 'Phạm A. Tuấn', isHighlight: true, colorType: 'blue', itemRef: timelineMockData.phamTuan },
          { time: '13:30', name: 'Bùi K. Duy', isHighlight: true, colorType: 'blue', itemRef: timelineMockData.buiDuy }
        ]
      },
      T7: {
        slots: [{ time: '09:00', name: 'Phạm A. Tuấn', isHighlight: true, colorType: 'blue' }]
      },
      CN: {
        slots: [
          { time: '10:00', name: 'Lý M. Tâm', colorType: 'gray' },
          { time: '12:00', name: 'Hồ T. Vy', colorType: 'gray' }
        ]
      }
    }
  },
  {
    roomName: 'Phòng máy 1',
    days: {
      T2: {
        slots: [
          { time: '09:00', name: 'Lê H. Phúc', colorType: 'gray' },
          { time: '11:00', name: 'Hồ T. Vy', colorType: 'gray' },
          { time: '13:00', name: 'Dương K. Oanh', colorType: 'gray' }
        ],
        extraCount: 2
      },
      T3: {
        slots: [
          { time: '09:00', name: 'Ngô T. Hằng', colorType: 'gray' },
          { time: '11:00', name: 'Trần B. Ngọc', colorType: 'gray' },
          { time: '11:00', name: 'Bùi Q. Đạt', colorType: 'gray' }
        ],
        extraCount: 3
      },
      T4: {
        slots: [
          { time: '09:00', name: 'Đặng H. Long', colorType: 'gray' },
          { time: '11:00', name: 'Đỗ V. Minh', colorType: 'gray' },
          { time: '13:00', name: 'Ngô T. Hằng', colorType: 'gray' }
        ],
        extraCount: 2
      },
      T5: {
        slots: [
          { time: '09:00', name: 'Dương K. Oanh', colorType: 'gray' },
          { time: '11:00', name: 'Võ T. Nhi', colorType: 'gray' },
          { time: '11:00', name: 'Phan V. Sơn', colorType: 'gray' }
        ],
        extraCount: 3
      },
      T6: {
        slots: [
          { time: '13:00', name: 'Cao V. Đạt', isHighlight: true, colorType: 'teal', itemRef: timelineMockData.caoNam },
          { time: '14:00', name: 'Vũ M. Châu', isHighlight: true, colorType: 'teal', itemRef: timelineMockData.vuChau },
          { time: '15:00', name: 'Ngô T. Linh', isHighlight: true, colorType: 'red', itemRef: timelineMockData.ngoLoc }
        ]
      },
      T7: { slots: [] },
      CN: {
        slots: [
          { time: '11:00', name: 'Đỗ V. Minh', colorType: 'gray' },
          { time: '13:00', name: 'Ngô T. Hằng', colorType: 'gray' },
          { time: '15:00', name: 'Bùi Q. Đạt', colorType: 'gray' }
        ]
      }
    }
  },
  {
    roomName: 'Phòng máy 2',
    days: {
      T2: {
        slots: [
          { time: '08:00', name: 'Đặng H. Long', colorType: 'gray' },
          { time: '12:00', name: 'Ngô T. Hằng', colorType: 'gray' },
          { time: '14:00', name: 'Bùi Q. Đạt', colorType: 'gray' }
        ],
        extraCount: 1
      },
      T3: {
        slots: [
          { time: '08:00', name: 'Dương K. Oanh', colorType: 'gray' },
          { time: '10:00', name: 'Phan V. Sơn', colorType: 'gray' },
          { time: '12:00', name: 'Đặng H. Long', colorType: 'gray' }
        ],
        extraCount: 2
      },
      T4: {
        slots: [
          { time: '08:00', name: 'Lê H. Phúc', colorType: 'gray' },
          { time: '12:00', name: 'Dương K. Oanh', colorType: 'gray' },
          { time: '14:00', name: 'Phan V. Sơn', colorType: 'gray' }
        ],
        extraCount: 1
      },
      T5: {
        slots: [
          { time: '08:00', name: 'Ngô T. Hằng', colorType: 'gray' },
          { time: '10:00', name: 'Bùi Q. Đạt', colorType: 'gray' },
          { time: '12:00', name: 'Lê H. Phúc', colorType: 'gray' }
        ],
        extraCount: 2
      },
      T6: {
        slots: [
          { time: '13:15', name: 'Trịnh V. Sơn', isHighlight: true, colorType: 'teal' },
          { time: '14:35', name: 'Nguyễn V. Phú', isHighlight: true, colorType: 'blue' },
          { time: '16:10', name: 'Đinh K. Hoà', isHighlight: true, colorType: 'red' }
        ]
      },
      T7: { slots: [] },
      CN: {
        slots: [
          { time: '12:00', name: 'Dương K. Oanh', colorType: 'gray' },
          { time: '14:00', name: 'Phan V. Sơn', colorType: 'gray' },
          { time: '16:00', name: 'Trần B. Ngọc', colorType: 'gray' }
        ]
      }
    }
  }
];

// 4. Dữ liệu Lịch Chế độ Xem Tháng (Tháng 08/2026 - 5 Tuần)
interface MonthDayData {
  dayNum: number;
  dateStr: string;
  isCurrentMonth: boolean;
  isToday?: boolean;
  totalCases: number;
  capacity: number;
  revenue: string;
  newhairCount?: number;
  clinicCount?: number;
  pttmCount?: number;
  hauPhauCount?: number;
  sampleCases?: { name: string; channel: string }[];
}

const monthViewMockData: MonthDayData[] = [
  // Tuần 1 (Tháng 7/8)
  { dayNum: 27, dateStr: '27/07', isCurrentMonth: false, totalCases: 11, capacity: 22, revenue: '290 tr' },
  { dayNum: 28, dateStr: '28/07', isCurrentMonth: false, totalCases: 14, capacity: 28, revenue: '380 tr' },
  { dayNum: 29, dateStr: '29/07', isCurrentMonth: false, totalCases: 10, capacity: 20, revenue: '260 tr' },
  { dayNum: 30, dateStr: '30/07', isCurrentMonth: false, totalCases: 15, capacity: 30, revenue: '410 tr' },
  { dayNum: 31, dateStr: '31/07', isCurrentMonth: false, totalCases: 16, capacity: 32, revenue: '450 tr' },
  { dayNum: 1, dateStr: '01/08', isCurrentMonth: true, totalCases: 22, capacity: 44, revenue: '680 tr', newhairCount: 6, clinicCount: 10, pttmCount: 4, hauPhauCount: 2 },
  { dayNum: 2, dateStr: '02/08', isCurrentMonth: true, totalCases: 19, capacity: 38, revenue: '590 tr', newhairCount: 5, clinicCount: 9, pttmCount: 3, hauPhauCount: 2 },

  // Tuần 2
  { dayNum: 3, dateStr: '03/08', isCurrentMonth: true, totalCases: 12, capacity: 24, revenue: '320 tr', newhairCount: 3, clinicCount: 6, pttmCount: 2, hauPhauCount: 1 },
  { dayNum: 4, dateStr: '04/08', isCurrentMonth: true, totalCases: 15, capacity: 30, revenue: '430 tr', newhairCount: 4, clinicCount: 8, pttmCount: 2, hauPhauCount: 1 },
  { dayNum: 5, dateStr: '05/08', isCurrentMonth: true, totalCases: 18, capacity: 36, revenue: '510 tr', newhairCount: 5, clinicCount: 9, pttmCount: 3, hauPhauCount: 1 },
  { dayNum: 6, dateStr: '06/08', isCurrentMonth: true, totalCases: 14, capacity: 28, revenue: '390 tr', newhairCount: 4, clinicCount: 7, pttmCount: 2, hauPhauCount: 1 },
  { dayNum: 7, dateStr: '07/08', isCurrentMonth: true, totalCases: 20, capacity: 40, revenue: '610 tr', newhairCount: 6, clinicCount: 10, pttmCount: 3, hauPhauCount: 1 },
  { dayNum: 8, dateStr: '08/08', isCurrentMonth: true, totalCases: 25, capacity: 50, revenue: '820 tr', newhairCount: 8, clinicCount: 11, pttmCount: 4, hauPhauCount: 2 },
  { dayNum: 9, dateStr: '09/08', isCurrentMonth: true, totalCases: 21, capacity: 42, revenue: '690 tr', newhairCount: 6, clinicCount: 10, pttmCount: 3, hauPhauCount: 2 },

  // Tuần 3
  { dayNum: 10, dateStr: '10/08', isCurrentMonth: true, totalCases: 13, capacity: 26, revenue: '350 tr', newhairCount: 3, clinicCount: 7, pttmCount: 2, hauPhauCount: 1 },
  { dayNum: 11, dateStr: '11/08', isCurrentMonth: true, totalCases: 16, capacity: 32, revenue: '480 tr', newhairCount: 5, clinicCount: 8, pttmCount: 2, hauPhauCount: 1 },
  { dayNum: 12, dateStr: '12/08', isCurrentMonth: true, totalCases: 17, capacity: 34, revenue: '520 tr', newhairCount: 4, clinicCount: 9, pttmCount: 3, hauPhauCount: 1 },
  { dayNum: 13, dateStr: '13/08', isCurrentMonth: true, totalCases: 15, capacity: 30, revenue: '420 tr', newhairCount: 4, clinicCount: 8, pttmCount: 2, hauPhauCount: 1 },
  { dayNum: 14, dateStr: '14/08', isCurrentMonth: true, totalCases: 19, capacity: 38, revenue: '580 tr', newhairCount: 5, clinicCount: 10, pttmCount: 3, hauPhauCount: 1 },
  { dayNum: 15, dateStr: '15/08', isCurrentMonth: true, totalCases: 24, capacity: 48, revenue: '780 tr', newhairCount: 7, clinicCount: 11, pttmCount: 4, hauPhauCount: 2 },
  { dayNum: 16, dateStr: '16/08', isCurrentMonth: true, totalCases: 20, capacity: 40, revenue: '640 tr', newhairCount: 6, clinicCount: 9, pttmCount: 3, hauPhauCount: 2 },

  // Tuần 4
  { dayNum: 17, dateStr: '17/08', isCurrentMonth: true, totalCases: 14, capacity: 28, revenue: '380 tr', newhairCount: 4, clinicCount: 7, pttmCount: 2, hauPhauCount: 1 },
  { dayNum: 18, dateStr: '18/08', isCurrentMonth: true, totalCases: 15, capacity: 30, revenue: '440 tr', newhairCount: 4, clinicCount: 8, pttmCount: 2, hauPhauCount: 1 },
  { dayNum: 19, dateStr: '19/08', isCurrentMonth: true, totalCases: 16, capacity: 32, revenue: '490 tr', newhairCount: 5, clinicCount: 8, pttmCount: 2, hauPhauCount: 1 },
  { dayNum: 20, dateStr: '20/08', isCurrentMonth: true, totalCases: 18, capacity: 36, revenue: '560 tr', newhairCount: 5, clinicCount: 9, pttmCount: 3, hauPhauCount: 1 },
  { dayNum: 21, dateStr: '21/08', isCurrentMonth: true, totalCases: 21, capacity: 42, revenue: '670 tr', newhairCount: 6, clinicCount: 10, pttmCount: 4, hauPhauCount: 1 },
  { dayNum: 22, dateStr: '22/08', isCurrentMonth: true, totalCases: 26, capacity: 52, revenue: '890 tr', newhairCount: 8, clinicCount: 12, pttmCount: 4, hauPhauCount: 2 },
  { dayNum: 23, dateStr: '23/08', isCurrentMonth: true, totalCases: 22, capacity: 44, revenue: '710 tr', newhairCount: 7, clinicCount: 10, pttmCount: 3, hauPhauCount: 2 },

  // Tuần 5 (Có ngày Hôm nay 28/08)
  { dayNum: 24, dateStr: '24/08', isCurrentMonth: true, totalCases: 15, capacity: 30, revenue: '430 tr', newhairCount: 4, clinicCount: 8, pttmCount: 2, hauPhauCount: 1 },
  { dayNum: 25, dateStr: '25/08', isCurrentMonth: true, totalCases: 17, capacity: 34, revenue: '510 tr', newhairCount: 5, clinicCount: 8, pttmCount: 3, hauPhauCount: 1 },
  { dayNum: 26, dateStr: '26/08', isCurrentMonth: true, totalCases: 16, capacity: 32, revenue: '480 tr', newhairCount: 4, clinicCount: 9, pttmCount: 2, hauPhauCount: 1 },
  { dayNum: 27, dateStr: '27/08', isCurrentMonth: true, totalCases: 19, capacity: 38, revenue: '590 tr', newhairCount: 5, clinicCount: 10, pttmCount: 3, hauPhauCount: 1 },
  { 
    dayNum: 28, 
    dateStr: '28/08', 
    isCurrentMonth: true, 
    isToday: true, 
    totalCases: 18, 
    capacity: 36, 
    revenue: '672 tr', 
    newhairCount: 4, 
    clinicCount: 8, 
    pttmCount: 5, 
    hauPhauCount: 1,
    sampleCases: [
      { name: 'Nguyễn T. Mai Anh', channel: 'PTTM' },
      { name: 'Lê V. Đức', channel: 'Newhair' },
      { name: 'Phạm A. Tuấn', channel: 'Newhair' }
    ] 
  },
  { dayNum: 29, dateStr: '29/08', isCurrentMonth: true, totalCases: 23, capacity: 46, revenue: '780 tr', newhairCount: 7, clinicCount: 11, pttmCount: 3, hauPhauCount: 2 },
  { dayNum: 30, dateStr: '30/08', isCurrentMonth: true, totalCases: 20, capacity: 40, revenue: '650 tr', newhairCount: 6, clinicCount: 10, pttmCount: 3, hauPhauCount: 1 },

  // Ngày lẻ tháng 9
  { dayNum: 31, dateStr: '31/08', isCurrentMonth: true, totalCases: 16, capacity: 32, revenue: '470 tr', newhairCount: 4, clinicCount: 8, pttmCount: 3, hauPhauCount: 1 }
];

const hours = ['07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00'];

const weekDaysList = [
  { key: 'T2', label: 'T2 · 24/8' },
  { key: 'T3', label: 'T3 · 25/8' },
  { key: 'T4', label: 'T4 · 26/8' },
  { key: 'T5', label: 'T5 · 27/8' },
  { key: 'T6', label: 'T6 · 28/8', isToday: true },
  { key: 'T7', label: 'T7 · 29/8' },
  { key: 'CN', label: 'CN · 30/8' }
];

const monthHeaders = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'];

export default function ExecutionSchedulePerfect() {
  const [activeTab, setActiveTab] = useState<string>('Phòng');
  const [activeViewMode, setActiveViewMode] = useState<string>('Ngày'); // 'Ngày' | 'Tuần' | 'Tháng'
  const [selectedBranch, setSelectedBranch] = useState<string>('Tất cả');
  const [searchWaiting, setSearchWaiting] = useState<string>('');

  // State quản lý item đang được chọn để hiển thị panel bên phải
  const [selectedItem, setSelectedItem] = useState<ScheduleItem | null>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  const handleSelectItem = (item: ScheduleItem) => {
    setSelectedItem(item);
    setIsDrawerOpen(true);
  };

  // Lọc danh sách chờ xếp
  const filteredWaitingList = useMemo(() => {
    return waitingListMock.filter((item) => {
      const matchSearch =
        item.name.toLowerCase().includes(searchWaiting.toLowerCase()) ||
        item.service.toLowerCase().includes(searchWaiting.toLowerCase()) ||
        item.code.toLowerCase().includes(searchWaiting.toLowerCase());
      const matchBranch = selectedBranch === 'Tất cả' || item.channel === selectedBranch;
      return matchSearch && matchBranch;
    });
  }, [searchWaiting, selectedBranch]);

  // Helper render highlight viền khi card đang được chọn
  const getCardStyle = (itemId: string, defaultBgClass: string, channel: string) => {
    const isSelected = selectedItem?.id === itemId;
    const isDimmed = selectedBranch !== 'Tất cả' && channel !== selectedBranch;

    return `absolute rounded px-2 py-1 shadow-2xs cursor-pointer transition-all duration-150 hover:scale-[1.02] hover:z-30 ${defaultBgClass} ${
      isSelected ? 'ring-2 ring-blue-600 z-20 shadow-md' : 'hover:ring-1 hover:ring-blue-400'
    } ${isDimmed ? 'opacity-30' : 'opacity-100'}`;
  };

  // Class styling cho các chip ca trong chế độ xem Tuần (Hình 1)
  const getWeekSlotBadgeClass = (slot: WeekSlot) => {
    if (!slot.isHighlight) {
      return 'bg-slate-100 text-slate-600 border-slate-200';
    }
    switch (slot.colorType) {
      case 'amber':
        return 'bg-amber-50 text-amber-900 border-amber-300 font-semibold';
      case 'emerald':
        return 'bg-emerald-50 text-emerald-900 border-emerald-300 font-semibold';
      case 'blue':
        return 'bg-blue-50 text-blue-900 border-blue-300 font-semibold';
      case 'teal':
        return 'bg-teal-50 text-teal-900 border-teal-300 font-semibold';
      case 'red':
        return 'bg-red-50 text-red-900 border-red-300 font-semibold';
      default:
        return 'bg-slate-100 text-slate-700 border-slate-300';
    }
  };

  return (
    <div className="p-4 bg-[#f0f2f5] min-h-screen text-slate-800 text-xs font-sans space-y-4">
      {/* ================= 1. HEADER & DASHBOARD CARDS ================= */}
      <div className="bg-white p-4 rounded-lg border border-slate-200 shadow-2xs">
        <div className="mb-3 flex items-start justify-between">
          <div>
            <h1 className="text-base font-bold text-slate-900 flex items-center gap-2">
              <Calendar className="w-5 h-5 text-teal-700" />
              Lịch thực hiện
            </h1>
            <p className="text-slate-500 text-[11px] mt-0.5">
              Trục hai tầng: nhóm theo phòng, trong mỗi phòng chia lane theo bác sĩ hoặc KTV. Ca đã chốt ở Lịch tư vấn rơi vào cột “Chờ xếp lịch” bên trái, kéo vào khe trống trên timeline để xếp.
            </p>
          </div>
        </div>

        {/* Thanh công cụ */}
        <div className="flex flex-wrap items-center justify-between gap-3 pb-3 mb-3 border-b border-slate-100">
          <div className="flex items-center flex-wrap gap-2">
            {/* Bộ lọc Trụ Kinh Doanh */}
            <div className="inline-flex items-center border border-slate-200 rounded-lg bg-white px-2.5 py-0.5 shadow-2xs hover:border-slate-300 transition-all">
              <span className="text-slate-400 text-xs font-normal whitespace-nowrap mr-1">
                Trụ KD:
              </span>
              <Select
                value={selectedBranch}
                onChange={setSelectedBranch}
                options={BRANCH_OPTIONS}
                variant="borderless"
                size="small"
                className="font-bold text-xs text-slate-800 w-28 [&_.ant-select-selection-item]:font-bold [&_.ant-select-selection-item]:text-slate-800"
                popupClassName="custom-branch-select-dropdown"
              />
            </div>

            {/* Điều hướng thời gian */}
            <div className="flex items-center border border-slate-200 rounded-md overflow-hidden bg-white text-slate-700">
              <button className="px-2.5 py-1.5 text-slate-500 hover:bg-slate-50 border-r border-slate-200 transition-colors">
                <ChevronLeft className="w-3.5 h-3.5" />
              </button>
              <span className="px-3 py-1.5 font-semibold text-slate-800 flex items-center gap-1.5">
                <Calendar className="w-3.5 h-3.5 text-slate-400" />
                {activeViewMode === 'Tháng'
                  ? 'Tháng 08/2026'
                  : activeViewMode === 'Tuần'
                  ? 'Tuần 24/08 – 30/08/2026'
                  : 'Thứ 6, 28/08/2026'}
              </span>
              <span className="text-slate-300">•</span>
              <button className="px-2.5 py-1.5 text-slate-600 hover:bg-slate-50 font-medium">Hôm nay</button>
              <span className="text-slate-300">•</span>
              <span className="px-2.5 py-1.5 text-slate-700 flex items-center gap-1">
                <Building2 className="w-3.5 h-3.5 text-slate-400" />
                Cơ sở Nguyễn Thị Minh Khai
              </span>
              <button className="px-2.5 py-1.5 text-slate-500 hover:bg-slate-50 border-l border-slate-200 transition-colors">
                <ChevronRight className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>

          <div className="flex items-center flex-wrap gap-2">
            <span className="text-slate-400 font-bold text-[10px] tracking-wider">CẤP</span>
            <div className="flex bg-slate-100 p-0.5 rounded-md text-slate-600">
              {['Ngày', 'Tuần', 'Tháng'].map((m) => (
                <button
                  key={m}
                  onClick={() => setActiveViewMode(m)}
                  className={`px-3 py-1 rounded text-[11px] font-medium transition-all ${
                    activeViewMode === m ? 'bg-white text-slate-900 shadow-2xs font-bold' : 'hover:text-slate-900'
                  }`}
                >
                  {m}
                </button>
              ))}
            </div>

            <span className="text-slate-400 font-bold text-[10px] tracking-wider ml-2">TRỤC</span>
            <div className="flex bg-slate-100 p-0.5 rounded-md text-slate-600">
              {['Phòng', 'Bác sĩ', 'Thiết bị', 'Danh sách'].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-2.5 py-1 rounded text-[11px] font-medium transition-all ${
                    activeTab === tab ? 'bg-white text-slate-900 shadow-2xs font-bold' : 'hover:text-slate-900'
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* 6 Thẻ Thống Kê */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          <div className="p-3 rounded-md border border-slate-200 bg-white shadow-2xs">
            <div className="text-[10px] uppercase font-bold text-slate-400 tracking-wider flex items-center justify-between">
              CÔNG SUẤT
              <Activity className="w-3.5 h-3.5 text-blue-500" />
            </div>
            <div className="text-xl font-extrabold text-blue-600 mt-1">36%</div>
          </div>
          <div className="p-3 rounded-md border border-slate-200 bg-white shadow-2xs">
            <div className="text-[10px] uppercase font-bold text-slate-400 tracking-wider flex items-center justify-between">
              CA HÔM NAY
              <Users className="w-3.5 h-3.5 text-slate-400" />
            </div>
            <div className="text-xl font-extrabold text-slate-800 mt-1">
              18 <span className="text-xs font-normal text-slate-500">ca</span>
            </div>
          </div>
          <div className="p-3 rounded-md border border-slate-200 bg-white shadow-2xs">
            <div className="text-[10px] uppercase font-bold text-slate-400 tracking-wider flex items-center justify-between">
              DOANH THU DỰ KIẾN
              <DollarSign className="w-3.5 h-3.5 text-emerald-500" />
            </div>
            <div className="text-xl font-extrabold text-emerald-600 mt-1">
              672 <span className="text-xs font-normal text-slate-500">tr</span>
            </div>
          </div>
          <div className="p-3 rounded-md border border-slate-200 bg-white shadow-2xs">
            <div className="text-[10px] uppercase font-bold text-slate-400 tracking-wider flex items-center justify-between">
              CHỜ XẾP LỊCH
              <Clock className="w-3.5 h-3.5 text-amber-500" />
            </div>
            <div className="text-xl font-extrabold text-amber-600 mt-1">
              {waitingListMock.length} <span className="text-xs font-normal text-slate-500">ca</span>
            </div>
          </div>
          <div className="p-3 rounded-md border border-slate-200 bg-white shadow-2xs">
            <div className="text-[10px] uppercase font-bold text-slate-400 tracking-wider flex items-center justify-between">
              CHƯA SẴN SÀNG
              <AlertCircle className="w-3.5 h-3.5 text-red-500" />
            </div>
            <div className="text-xl font-extrabold text-red-500 mt-1">
              7 <span className="text-xs font-normal text-slate-500">ca</span>
            </div>
          </div>
          <div className="p-3 rounded-md border border-slate-200 bg-white shadow-2xs">
            <div className="text-[10px] uppercase font-bold text-slate-400 tracking-wider flex items-center justify-between">
              NGUY CƠ NO-SHOW
              <AlertTriangle className="w-3.5 h-3.5 text-red-600" />
            </div>
            <div className="text-xl font-extrabold text-red-600 mt-1">
              1 <span className="text-xs font-normal text-slate-500">ca</span>
            </div>
          </div>
        </div>
      </div>

      {/* ================= 2. KHU VỰC CHÍNH: CHỜ XẾP LỊCH, (THÁNG / TUẦN / NGÀY) & PANEL CHI TIẾT ================= */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-start">
        {/* Cột trái: Chờ xếp lịch */}
        <div className="lg:col-span-3 xl:col-span-2 bg-white p-3 rounded-lg border border-slate-200 shadow-2xs">
          <div className="flex items-center justify-between pb-2 mb-2 border-b border-slate-100 font-bold text-slate-700">
            <span className="flex items-center gap-1.5">
              <Clock className="w-3.5 h-3.5 text-amber-600" />
              CHỜ XẾP LỊCH
            </span>
            <span className="bg-amber-50 text-amber-700 border border-amber-200 px-1.5 py-0.5 rounded text-[10px] font-bold">
              {filteredWaitingList.length}
            </span>
          </div>

          {/* Tìm kiếm ca chờ */}
          <div className="relative mb-2.5">
            <Search className="w-3.5 h-3.5 text-slate-400 absolute left-2.5 top-2.5" />
            <input
              type="text"
              placeholder="Tìm tên, dịch vụ, mã ca..."
              value={searchWaiting}
              onChange={(e) => setSearchWaiting(e.target.value)}
              className="w-full pl-8 pr-2.5 py-1.5 bg-slate-50 border border-slate-200 rounded text-[11px] focus:outline-none focus:border-blue-400 focus:bg-white transition-all"
            />
          </div>

          <div className="text-[10px] text-slate-500 mb-3 leading-relaxed">
            Ca đã chốt ở bước Lịch tư vấn, chờ điều phối. Chọn một ca để hệ thống hiện khe trống hợp lệ trên timeline.
          </div>

          <div className="space-y-2 max-h-[calc(100vh-320px)] overflow-y-auto pr-1">
            {filteredWaitingList.length === 0 ? (
              <div className="text-center py-6 text-slate-400">Không tìm thấy ca phù hợp</div>
            ) : (
              filteredWaitingList.map((item) => (
                <div
                  key={item.id}
                  onClick={() => handleSelectItem(item)}
                  className={`p-2.5 rounded-md border cursor-pointer transition-all ${
                    selectedItem?.id === item.id
                      ? 'border-blue-500 bg-blue-50/40 ring-1 ring-blue-400 shadow-xs'
                      : 'border-slate-200 bg-slate-50/50 hover:border-blue-400 hover:bg-white'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-bold text-slate-900">{item.name}</span>
                    <span className="text-[9px] font-semibold text-slate-500 bg-slate-200 px-1 py-0.5 rounded">
                      {item.code}
                    </span>
                  </div>
                  <div className="text-slate-600 font-medium truncate mt-0.5">{item.service}</div>
                  <div className="text-slate-400 text-[10px] mt-1">{item.timeInfo}</div>
                  {item.statusText && (
                    <div
                      className={`mt-2 inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-medium ${
                        item.statusType === 'error'
                          ? 'bg-red-50 text-red-600 border border-red-200'
                          : item.statusType === 'warning'
                          ? 'bg-amber-50 text-amber-700 border border-amber-200'
                          : 'bg-emerald-50 text-emerald-700 border border-emerald-200'
                      }`}
                    >
                      {item.statusType === 'error' && <AlertCircle className="w-3 h-3 shrink-0" />}
                      {item.statusType === 'warning' && <AlertTriangle className="w-3 h-3 shrink-0" />}
                      {item.statusType === 'default' && <CheckCircle2 className="w-3 h-3 shrink-0" />}
                      <span className="truncate">{item.statusText}</span>
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>

        {/* Cột giữa: CÁC MÀN HÌNH THEO CHẾ ĐỘ XEM (THÁNG / TUẦN / NGÀY) */}
        <div
          className={`${
            isDrawerOpen ? 'lg:col-span-9 xl:col-span-8' : 'lg:col-span-9 xl:col-span-10'
          } space-y-3 transition-all duration-300`}
        >
          {/* ==================== MÀN HÌNH BẢNG DANH SÁCH (KHI ACTIVE TAB = 'DANH SÁCH') ==================== */}
          {activeTab === 'Danh sách' ? (
            <div className="bg-white p-4 rounded-lg border border-slate-200 shadow-2xs space-y-3">
              {/* Header & Bộ lọc của Bảng danh sách */}
              <div className="flex flex-wrap items-center justify-between gap-3 pb-3 border-b border-slate-100">
                <div className="flex items-center gap-2">
                  <h2 className="text-sm font-bold text-slate-900">Danh sách ca thực hiện trong ngày</h2>
                  <span className="bg-blue-50 text-blue-700 border border-blue-200 text-[10px] font-bold px-2 py-0.5 rounded-full">
                    {Object.keys(timelineMockData).length} ca
                  </span>
                </div>

                <div className="flex items-center flex-wrap gap-2">
                  {/* Ô tìm kiếm */}
                  <div className="relative">
                    <Search className="w-3.5 h-3.5 text-slate-400 absolute left-2.5 top-2.5" />
                    <input
                      type="text"
                      placeholder="Tìm tên, mã ca, dịch vụ..."
                      className="pl-8 pr-3 py-1.5 bg-slate-50 border border-slate-200 rounded-md text-[11px] focus:outline-none focus:border-blue-400 focus:bg-white w-52 transition-all"
                    />
                  </div>

                  {/* Nút Xuất Excel */}
                  <button className="flex items-center gap-1.5 px-3 py-1.5 bg-slate-100 hover:bg-slate-200 text-slate-700 font-medium rounded-md border border-slate-200 text-[11px] transition-colors">
                    <FileText className="w-3.5 h-3.5 text-slate-500" />
                    Xuất Excel
                  </button>
                </div>
              </div>

              {/* Bảng dữ liệu */}
              <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse border border-slate-200 text-[11px]">
                  <thead>
                    <tr className="bg-slate-50 text-slate-600 border-b border-slate-200 font-bold uppercase text-[10px]">
                      <th className="p-2.5 border-r border-slate-200">Mã ca</th>
                      <th className="p-2.5 border-r border-slate-200">Khách hàng</th>
                      <th className="p-2.5 border-r border-slate-200">Dịch vụ</th>
                      <th className="p-2.5 border-r border-slate-200">Trụ KD</th>
                      <th className="p-2.5 border-r border-slate-200">Phòng & Khung giờ</th>
                      <th className="p-2.5 border-r border-slate-200">Nhân sự phụ trách</th>
                      <th className="p-2.5 border-r border-slate-200 text-right">Giá trị</th>
                      <th className="p-2.5 border-r border-slate-200">Hồ sơ / Checklist</th>
                      <th className="p-2.5 border-r border-slate-200">Trạng thái</th>
                      <th className="p-2.5 text-center">Thao tác</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200">
                    {Object.values(timelineMockData).map((item) => (
                      <tr
                        key={item.id}
                        onClick={() => handleSelectItem(item)}
                        className={`hover:bg-blue-50/40 cursor-pointer transition-colors ${
                          selectedItem?.id === item.id ? 'bg-blue-50/60 font-medium' : ''
                        }`}
                      >
                        <td className="p-2.5 border-r border-slate-200 font-mono font-bold text-slate-700">
                          {item.code}
                        </td>
                        <td className="p-2.5 border-r border-slate-200">
                          <div className="font-bold text-slate-900">{item.name}</div>
                          <div className="text-[10px] text-slate-400">0903***123 • Nữ</div>
                        </td>
                        <td className="p-2.5 border-r border-slate-200 text-slate-800 font-medium">
                          {item.service}
                        </td>
                        <td className="p-2.5 border-r border-slate-200">
                          <span
                            className={`px-2 py-0.5 rounded text-[10px] font-bold border ${
                              item.channel === 'PTTM'
                                ? 'bg-amber-50 text-amber-800 border-amber-200'
                                : item.channel === 'Newhair'
                                ? 'bg-blue-50 text-blue-800 border-blue-200'
                                : item.channel === 'Clinic'
                                ? 'bg-emerald-50 text-emerald-800 border-emerald-200'
                                : 'bg-purple-50 text-purple-800 border-purple-200'
                            }`}
                          >
                            {item.channel}
                          </span>
                        </td>
                        <td className="p-2.5 border-r border-slate-200 text-slate-700">
                          <div className="font-medium">Phòng mổ 1</div>
                          <div className="text-[10px] text-slate-500 font-mono">{item.expectedTime}</div>
                        </td>
                        <td className="p-2.5 border-r border-slate-200 text-slate-800">
                          {item.consultant}
                        </td>
                        <td className="p-2.5 border-r border-slate-200 text-right font-semibold text-slate-900">
                          {item.price}
                        </td>
                        <td className="p-2.5 border-r border-slate-200 text-slate-600">
                          {item.checklist}
                        </td>
                        <td className="p-2.5 border-r border-slate-200">
                          <span
                            className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-medium border ${
                              item.status === 'Hoàn tất'
                                ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
                                : item.status === 'Đang thực hiện'
                                ? 'bg-blue-50 text-blue-700 border-blue-200'
                                : item.status === 'Check-in'
                                ? 'bg-teal-50 text-teal-700 border-teal-200'
                                : item.statusType === 'warning'
                                ? 'bg-amber-50 text-amber-700 border-amber-200'
                                : 'bg-slate-100 text-slate-700 border-slate-200'
                            }`}
                          >
                            {item.status}
                          </span>
                        </td>
                        <td className="p-2.5 text-center">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSelectItem(item);
                            }}
                            className="p-1 hover:bg-slate-100 rounded text-slate-500 hover:text-blue-600 transition-colors"
                          >
                            <Edit3 className="w-3.5 h-3.5" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            /* Các chế độ xem Ngày / Tuần / Tháng hiện tại */
            <>
              {/* ==================== MÀN HÌNH 3: HIỂN THỊ KHI CHỌN "THÁNG" ==================== */}
              {activeViewMode === 'Tháng' ? (
                <div className="bg-white p-4 rounded-lg border border-slate-200 shadow-2xs space-y-3">
                  {/* Header của Lịch Tháng */}
                  <div className="flex flex-wrap items-center justify-between gap-2 pb-2 border-b border-slate-100">
                    <div>
                      <div className="text-sm font-bold text-slate-900 flex items-center gap-2">
                        <span>Lịch Thực Hiện Tháng 08 / 2026</span>
                        <span className="text-[11px] font-semibold text-teal-700 bg-teal-50 px-2 py-0.5 rounded border border-teal-200">
                          Tổng 540 ca • Doanh thu ~16.2 Tỷ
                        </span>
                      </div>
                      <p className="text-[11px] text-slate-500 mt-0.5">
                        Tổng quan mật độ ca và tải công suất theo từng ngày. Nhấn vào một ngày bất kỳ để đi tới Lịch Ngày.
                      </p>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-[10px] text-slate-400 font-semibold uppercase">Mật độ:</span>
                      <div className="flex items-center gap-1.5 text-[10px] text-slate-600">
                        <span className="w-2.5 h-2.5 rounded bg-emerald-100 border border-emerald-300 inline-block"></span> Thấp (&lt;30%)
                        <span className="w-2.5 h-2.5 rounded bg-amber-100 border border-amber-300 inline-block ml-1"></span> Vừa (30-45%)
                        <span className="w-2.5 h-2.5 rounded bg-red-100 border border-red-300 inline-block ml-1"></span> Cao (&gt;45%)
                      </div>
                    </div>
                  </div>

                  {/* Bảng Calendar Grid 7 cột */}
                  <div className="overflow-x-auto">
                    <div className="min-w-[800px]">
                      {/* Tiêu đề 7 ngày trong tuần */}
                      <div className="grid grid-cols-7 bg-slate-50 border border-slate-200 rounded-t-md text-center py-2 font-bold text-slate-600 text-[11px]">
                        {monthHeaders.map((dh) => (
                          <div key={dh}>{dh}</div>
                        ))}
                      </div>

                      {/* Lưới 35 ô ngày */}
                      <div className="grid grid-cols-7 border-l border-b border-r border-slate-200 divide-x divide-y divide-slate-200 bg-slate-50/20">
                        {monthViewMockData.map((d, index) => {
                          const isHighCapacity = d.capacity >= 45;
                          const isMediumCapacity = d.capacity >= 30 && d.capacity < 45;

                          return (
                            <div
                              key={index}
                              onClick={() => setActiveViewMode('Ngày')}
                              className={`min-h-[105px] p-2 transition-all cursor-pointer hover:bg-blue-50/50 flex flex-col justify-between group relative ${
                                !d.isCurrentMonth ? 'bg-slate-50/60 opacity-40' : 'bg-white'
                              } ${d.isToday ? 'ring-2 ring-blue-600 ring-inset bg-blue-50/20 z-10' : ''}`}
                            >
                              {/* Header Ngày */}
                              <div className="flex items-center justify-between">
                                <span
                                  className={`font-mono text-[11px] font-bold ${
                                    d.isToday
                                      ? 'bg-blue-600 text-white w-5 h-5 rounded-full flex items-center justify-center shadow-2xs'
                                      : d.isCurrentMonth
                                      ? 'text-slate-800'
                                      : 'text-slate-400'
                                  }`}
                                >
                                  {d.dayNum}
                                </span>
                                {d.isToday && (
                                  <span className="text-[9px] font-bold text-blue-700 bg-blue-100 px-1 rounded">
                                    Hôm nay
                                  </span>
                                )}
                                {d.isCurrentMonth && !d.isToday && (
                                  <span className="text-[9px] text-slate-400 group-hover:text-blue-600 font-medium">
                                    Xem ngày →
                                  </span>
                                )}
                              </div>

                              {/* Thống kê ca trong ngày */}
                              {d.isCurrentMonth ? (
                                <div className="my-1.5 space-y-1">
                                  <div className="flex items-center justify-between">
                                    <span className="font-extrabold text-slate-900 text-[12px] flex items-center gap-1">
                                      {d.totalCases} <span className="text-[10px] font-normal text-slate-500">ca</span>
                                    </span>
                                    <span className="font-semibold text-emerald-700 text-[10px]">{d.revenue}</span>
                                  </div>

                                  {/* Progress bar công suất */}
                                  <div className="w-full h-1.5 bg-slate-100 rounded-full overflow-hidden">
                                    <div
                                      className={`h-full rounded-full ${
                                        isHighCapacity ? 'bg-red-500' : isMediumCapacity ? 'bg-amber-500' : 'bg-emerald-500'
                                      }`}
                                      style={{ width: `${d.capacity * 2}%` }}
                                    ></div>
                                  </div>

                                  {/* Phân bổ các Trụ Kinh Doanh (dạng chip nhỏ) */}
                                  <div className="flex items-center flex-wrap gap-1 pt-0.5">
                                    {d.pttmCount && (
                                      <span className="bg-amber-50 text-amber-800 border border-amber-200 text-[8px] font-bold px-1 rounded">
                                        PTTM:{d.pttmCount}
                                      </span>
                                    )}
                                    {d.newhairCount && (
                                      <span className="bg-blue-50 text-blue-800 border border-blue-200 text-[8px] font-bold px-1 rounded">
                                        Hair:{d.newhairCount}
                                      </span>
                                    )}
                                    {d.clinicCount && (
                                      <span className="bg-emerald-50 text-emerald-800 border border-emerald-200 text-[8px] font-bold px-1 rounded">
                                        Cli:{d.clinicCount}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className="text-[10px] text-slate-400 italic my-auto text-center">
                                  {d.totalCases} ca
                                </div>
                              )}

                              {/* Ca mẫu đặc biệt (Nếu có) */}
                              {d.sampleCases && d.sampleCases.length > 0 && (
                                <div className="border-t border-slate-100 pt-1 space-y-0.5">
                                  {d.sampleCases.slice(0, 2).map((sc, sIdx) => (
                                    <div key={sIdx} className="text-[9px] truncate text-slate-600 font-medium flex items-center gap-1">
                                      <span className="w-1 h-1 rounded-full bg-blue-500 shrink-0"></span>
                                      <span className="truncate">{sc.name}</span>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>

                  {/* Chú thích cuối lịch Tháng */}
                  <div className="text-[10px] text-slate-500 pt-1 flex items-center justify-between">
                    <span>
                      Bấm vào bất kỳ ô ngày nào để xem lưới giờ chi tiết của ngày đó. Chuyển cấp xem ở thanh công cụ góc trên.
                    </span>
                    <span className="flex items-center gap-1 font-semibold text-slate-700">
                      <TrendingUp className="w-3.5 h-3.5 text-blue-600" /> Công suất trung bình tháng: 38%
                    </span>
                  </div>
                </div>
              ) : activeViewMode === 'Tuần' ? (
                /* ==================== MÀN HÌNH 1: HIỂN THỊ KHI CHỌN "TUẦN" ==================== */
                <div className="bg-white p-4 rounded-lg border border-slate-200 shadow-2xs space-y-3">
                  {/* Header của bảng Tuần */}
                  <div className="flex flex-wrap items-center justify-between gap-2 pb-2 border-b border-slate-100">
                    <div>
                      <div className="text-sm font-bold text-slate-900 flex items-center gap-2">
                        <span>Tuần 24/8 – 30/8</span>
                        <span className="text-[11px] font-semibold text-blue-700 bg-blue-50 px-2 py-0.5 rounded border border-blue-200">
                          hôm nay T6 28
                        </span>
                      </div>
                      <p className="text-[11px] text-slate-500 mt-0.5">
                        Trực Phòng – mỗi ô là danh sách ca của ngày đó, bấm ca để mở chi tiết
                      </p>
                    </div>
                    <button
                      onClick={() => setActiveViewMode('Ngày')}
                      className="px-2.5 py-1 bg-slate-100 hover:bg-blue-50 hover:text-blue-700 text-slate-600 rounded-md border border-slate-200 font-medium text-[11px] transition-colors flex items-center gap-1"
                    >
                      <span className="w-2 h-2 rounded-full bg-blue-600 inline-block"></span>
                      Bấm đầu cột ngày để mở lưới giờ
                    </button>
                  </div>

                  {/* Bảng ma trận Tuần (Phòng x 7 Ngày) */}
                  <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse border border-slate-200 text-[11px]">
                      <thead>
                        <tr className="bg-slate-50/80 text-slate-500 border-b border-slate-200">
                          <th className="p-2 border-r border-slate-200 font-bold uppercase w-[120px] text-[10px]">PHÒNG</th>
                          {weekDaysList.map((day) => (
                            <th
                              key={day.key}
                              onClick={() => setActiveViewMode('Ngày')}
                              className={`p-2 border-r border-slate-200 text-center cursor-pointer hover:bg-blue-50/60 transition-colors ${
                                day.isToday ? 'bg-blue-50/30 font-bold text-blue-800' : 'font-semibold text-slate-700'
                              }`}
                            >
                              <div className="flex items-center justify-center gap-1">
                                {day.label}
                                {day.isToday && <span className="w-1.5 h-1.5 rounded-full bg-blue-600 inline-block"></span>}
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-200">
                        {weekViewMockData.map((row, rIdx) => (
                          <tr key={rIdx} className="hover:bg-slate-50/30">
                            {/* Tên phòng */}
                            <td className="p-2 border-r border-slate-200 font-bold text-slate-800 bg-slate-50/30 align-top">
                              {row.roomName}
                            </td>

                            {/* Các ngày T2 -> CN */}
                            {weekDaysList.map((day) => {
                              const dayData = row.days[day.key] || { slots: [] };
                              return (
                                <td
                                  key={day.key}
                                  className={`p-1.5 border-r border-slate-200 align-top h-24 ${
                                    day.isToday ? 'bg-blue-50/10' : ''
                                  }`}
                                >
                                  <div className="space-y-1">
                                    {dayData.slots.map((slot, sIdx) => (
                                      <div
                                        key={sIdx}
                                        onClick={() => slot.itemRef && handleSelectItem(slot.itemRef)}
                                        className={`p-1 rounded text-[10px] border flex items-center justify-between cursor-pointer transition-all hover:scale-[1.02] ${getWeekSlotBadgeClass(
                                          slot
                                        )}`}
                                      >
                                        <span className="font-mono text-[9px] opacity-80 mr-1">{slot.time}</span>
                                        <span className="truncate font-medium flex-1">{slot.name}</span>
                                      </div>
                                    ))}

                                    {dayData.extraCount && (
                                      <div className="text-[9px] text-blue-600 bg-blue-50 border border-dashed border-blue-200 rounded px-1 py-0.5 text-center font-medium">
                                        +{dayData.extraCount} ca
                                      </div>
                                    )}
                                  </div>
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Chú thích cuối bảng Tuần */}
                  <div className="text-[10px] text-slate-500 pt-1 flex items-center justify-between">
                    <span>
                      Màu chip theo trạng thái ca. Chi tiết ca có ở 28–29/8; các ngày khác mô phỏng mật độ (chip mờ). Đổi Trục để xem theo bác sĩ hoặc thiết bị.
                    </span>
                  </div>
                </div>
              ) : (
                /* ==================== MÀN HÌNH 2: HIỂN THỊ KHI CHỌN "NGÀY" (LƯỚI TIMELINE GIỜ) ==================== */
                <div className="overflow-x-auto bg-white p-3 rounded-lg border border-slate-200 shadow-2xs">
                  <div className="min-w-[950px] relative">
                    {/* Vạch đỏ thời gian hiện tại */}
                    <div className="absolute top-0 bottom-0 left-[58%] w-[1px] bg-red-500 z-10 pointer-events-none">
                      <div className="w-2 h-2 bg-red-500 rounded-full -ml-[3.5px] -mt-1 shadow-xs"></div>
                    </div>

                    {/* HEADER GIỜ */}
                    <div className="flex border-b border-slate-200 pb-2 text-slate-400 font-semibold text-[11px] bg-slate-50/50 -mx-3 px-3">
                      <div className="w-[180px] shrink-0">PHÒNG - NHÂN SỰ</div>
                      <div className="flex flex-1">
                        {hours.map((h, idx) => (
                          <div key={idx} className="flex-1 text-center font-mono">
                            {h}
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* --- PHÒNG MỔ 1 --- */}
                    <div className="py-2.5 border-b border-slate-100">
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-2">
                          <span className="font-bold text-slate-800">Phòng mổ 1</span>
                          <span className="bg-amber-100 text-amber-800 px-1.5 py-0.5 rounded text-[9px] font-bold">PTTM</span>
                        </div>
                        <div className="flex items-center gap-2 text-slate-400 text-[11px]">
                          <span>Công suất 34%</span>
                          <div className="w-16 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                            <div className="w-[34%] h-full bg-amber-500 rounded-full"></div>
                          </div>
                        </div>
                      </div>

                      {/* BS. Long */}
                      <div className="flex items-center py-1 text-[11px] relative">
                        <div className="w-[180px] shrink-0 text-slate-600 pr-2">
                          <div className="font-semibold text-slate-800 flex items-center gap-1">
                            <User className="w-3 h-3 text-slate-400" /> BS. Long
                          </div>
                          <div className="text-[10px] text-slate-400 pl-4">Phẫu thuật viên chính</div>
                        </div>
                        <div className="flex-1 relative h-9 bg-slate-50/40 rounded flex items-center px-1 border border-slate-100">
                          <div
                            onClick={() => handleSelectItem(timelineMockData.maiAnh)}
                            className={`left-[20%] w-[25%] ${getCardStyle('t1', 'bg-[#fdfaf3] border border-amber-300', 'PTTM')}`}
                          >
                            <div className="font-bold text-slate-900 truncate">Nguyễn T. Mai Anh</div>
                            <div className="text-[10px] text-amber-700 truncate">Nâng mũi cấu trúc sụn sườn</div>
                            <span className="absolute right-1.5 bottom-0.5 text-[9px] text-slate-400 font-medium">12/12</span>
                          </div>
                        </div>
                      </div>

                      {/* BS. Hùng */}
                      <div className="flex items-center py-1 text-[11px] relative">
                        <div className="w-[180px] shrink-0 text-slate-600 pr-2">
                          <div className="font-semibold text-slate-800 flex items-center gap-1">
                            <User className="w-3 h-3 text-slate-400" /> BS. Hùng
                          </div>
                          <div className="text-[10px] text-slate-400 pl-4">Phẫu thuật viên</div>
                        </div>
                        <div className="flex-1 relative h-9 bg-slate-50/40 rounded flex items-center px-1 border border-slate-100">
                          <div
                            onClick={() => handleSelectItem(timelineMockData.doanYen)}
                            className={`left-[35%] w-[22%] ${getCardStyle(
                              't2',
                              'bg-[#fdfaf3] border border-dashed border-slate-300',
                              'PTTM'
                            )}`}
                          >
                            <div className="font-bold text-slate-900 truncate">Đoàn T. Yến</div>
                            <div className="text-[10px] text-slate-500 truncate">Cắt mí dưới</div>
                            <span className="absolute right-1.5 bottom-0.5 text-[9px] text-slate-400 font-medium">12/12</span>
                          </div>
                          <div
                            onClick={() => handleSelectItem(timelineMockData.tranHuy)}
                            className={`left-[62%] w-[22%] ${getCardStyle('t3', 'bg-[#fdfaf3] border border-amber-300', 'PTTM')}`}
                          >
                            <div className="font-bold text-slate-900 truncate">Trần Q. Huy</div>
                            <div className="text-[10px] text-amber-700 truncate">Cắt mí trên + treo cung mày</div>
                            <span className="absolute right-1.5 bottom-0.5 text-[9px] text-slate-400 font-medium">11/12</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* --- PHÒNG CẤY TÓC A --- */}
                    <div className="py-2.5 border-b border-slate-100">
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-2">
                          <span className="font-bold text-slate-800">Phòng cấy tóc A</span>
                          <span className="bg-blue-100 text-blue-800 px-1.5 py-0.5 rounded text-[9px] font-bold">NEWHAIR</span>
                        </div>
                        <div className="flex items-center gap-2 text-slate-400 text-[11px]">
                          <span>Công suất 34%</span>
                          <div className="w-16 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                            <div className="w-[34%] h-full bg-blue-500 rounded-full"></div>
                          </div>
                        </div>
                      </div>

                      {/* BS. Trâm */}
                      <div className="flex items-center py-1 text-[11px] relative">
                        <div className="w-[180px] shrink-0 text-slate-600 pr-2">
                          <div className="font-semibold text-slate-800 flex items-center gap-1">
                            <User className="w-3 h-3 text-slate-400" /> BS. Trâm
                          </div>
                          <div className="text-[10px] text-slate-400 pl-4">Cấy tóc</div>
                        </div>
                        <div className="flex-1 relative h-9 bg-slate-50/40 rounded flex items-center px-1 border border-slate-100">
                          <div
                            onClick={() => handleSelectItem(timelineMockData.leDuc)}
                            className={`left-[25%] w-[40%] ${getCardStyle('t4', 'bg-emerald-50 border border-emerald-300', 'Newhair')}`}
                          >
                            <div className="font-bold text-slate-900 truncate">Lê V. Đức</div>
                            <div className="text-[10px] text-emerald-700 truncate">Cấy tóc HAT 2.800 nang</div>
                            <span className="absolute right-1.5 bottom-0.5 text-[9px] text-slate-400 font-medium">10/10</span>
                          </div>
                        </div>
                      </div>

                      {/* Ekip cấy tóc 1 */}
                      <div className="flex items-center py-1 text-[11px] relative">
                        <div className="w-[180px] shrink-0 text-slate-600 pr-2">
                          <div className="font-semibold text-slate-800 flex items-center gap-1">
                            <Users className="w-3 h-3 text-slate-400" /> Ekip cấy tóc 1
                          </div>
                          <div className="text-[10px] text-slate-400 pl-4">4 KTV</div>
                        </div>
                        <div className="flex-1 relative h-9 bg-slate-50/40 rounded flex items-center px-1 border border-slate-100">
                          <div
                            onClick={() => handleSelectItem(timelineMockData.ekip1)}
                            className={`left-[25%] w-[40%] ${getCardStyle(
                              't5',
                              'bg-slate-50 border border-dashed border-slate-300',
                              'Newhair'
                            )}`}
                          >
                            <div className="font-bold text-slate-900 truncate">Khoá ekip – TH-2603</div>
                            <div className="text-[10px] text-slate-500 truncate">Ekip cấy tóc 1</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* --- PHÒNG CẤY TÓC B --- */}
                    <div className="py-2.5 border-b border-slate-100">
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-2">
                          <span className="font-bold text-slate-800">Phòng cấy tóc B</span>
                          <span className="bg-blue-100 text-blue-800 px-1.5 py-0.5 rounded text-[9px] font-bold">NEWHAIR</span>
                        </div>
                        <div className="flex items-center gap-2 text-slate-400 text-[11px]">
                          <span>Công suất 64%</span>
                          <div className="w-16 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                            <div className="w-[64%] h-full bg-blue-500 rounded-full"></div>
                          </div>
                        </div>
                      </div>

                      {/* BS. Khoa */}
                      <div className="flex items-center py-1 text-[11px] relative">
                        <div className="w-[180px] shrink-0 text-slate-600 pr-2">
                          <div className="font-semibold text-slate-800 flex items-center gap-1">
                            <User className="w-3 h-3 text-slate-400" /> BS. Khoa
                          </div>
                          <div className="text-[10px] text-slate-400 pl-4">Cấy tóc</div>
                        </div>
                        <div className="flex-1 relative h-9 bg-slate-50/40 rounded flex items-center px-1 border border-slate-100">
                          <div
                            onClick={() => handleSelectItem(timelineMockData.phamTuan)}
                            className={`left-[28%] w-[26%] ${getCardStyle('t6', 'bg-blue-50 border border-blue-300', 'Newhair')}`}
                          >
                            <div className="font-bold text-slate-900 truncate">Phạm A. Tuấn</div>
                            <div className="text-[10px] text-blue-700 truncate">Cấy tóc HAT 1.500 nang</div>
                            <span className="absolute right-1.5 bottom-0.5 text-[9px] text-slate-400 font-medium">8/10</span>
                          </div>
                          <div
                            onClick={() => handleSelectItem(timelineMockData.buiDuy)}
                            className={`left-[56%] w-[26%] ${getCardStyle('t7', 'bg-blue-50 border border-blue-300', 'Newhair')}`}
                          >
                            <div className="font-bold text-slate-900 truncate">Bùi K. Duy</div>
                            <div className="text-[10px] text-blue-700 truncate">Cấy tóc HAT 1.200 nang</div>
                            <span className="absolute right-1.5 bottom-0.5 text-[9px] text-slate-400 font-medium">9/10</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* --- PHÒNG MÁY 1 --- */}
                    <div className="py-2.5 border-b border-slate-100">
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-2">
                          <span className="font-bold text-slate-800">Phòng máy 1</span>
                          <span className="bg-emerald-100 text-emerald-800 px-1.5 py-0.5 rounded text-[9px] font-bold">CLINIC</span>
                        </div>
                        <div className="flex items-center gap-2 text-slate-400 text-[11px]">
                          <span>Công suất 39%</span>
                          <div className="w-16 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                            <div className="w-[39%] h-full bg-emerald-500 rounded-full"></div>
                          </div>
                        </div>
                      </div>

                      {/* KTV Ngân */}
                      <div className="flex items-center py-1 text-[11px] relative">
                        <div className="w-[180px] shrink-0 text-slate-600 pr-2">
                          <div className="font-semibold text-slate-800 flex items-center gap-1">
                            <User className="w-3 h-3 text-slate-400" /> KTV Ngân
                          </div>
                          <div className="text-[10px] text-slate-400 pl-4">Thermage / HIFU</div>
                        </div>
                        <div className="flex-1 relative h-9 bg-slate-50/40 rounded flex items-center px-1 border border-slate-100">
                          <div
                            onClick={() => handleSelectItem(timelineMockData.huanPhan)}
                            className={`left-[25%] w-[12%] ${getCardStyle(
                              't8',
                              'bg-slate-50 border border-dashed border-slate-300',
                              'Clinic'
                            )}`}
                          >
                            <div className="font-bold text-slate-900 truncate text-[10px]">Huan Phan...</div>
                            <div className="text-[9px] text-slate-500 truncate">K-Lift Signatu...</div>
                          </div>
                          <div
                            onClick={() => handleSelectItem(timelineMockData.doHa)}
                            className={`left-[38%] w-[12%] ${getCardStyle(
                              't9',
                              'bg-slate-50 border border-dashed border-slate-300',
                              'Clinic'
                            )}`}
                          >
                            <div className="font-bold text-slate-900 truncate text-[10px]">Đỗ T. Hà</div>
                            <div className="text-[9px] text-slate-500 truncate">K-Reskin A...</div>
                          </div>
                          <div
                            onClick={() => handleSelectItem(timelineMockData.vuChau)}
                            className={`left-[58%] w-[15%] ${getCardStyle('t10', 'bg-blue-50 border border-blue-300', 'Clinic')}`}
                          >
                            <div className="font-bold text-slate-900 truncate text-[10px]">Vũ M. Châu</div>
                            <div className="text-[9px] text-blue-700 truncate">K-Lift Advanced 7/8</div>
                          </div>
                        </div>
                      </div>

                      {/* KTV Vy */}
                      <div className="flex items-center py-1 text-[11px] relative">
                        <div className="w-[180px] shrink-0 text-slate-600 pr-2">
                          <div className="font-semibold text-slate-800 flex items-center gap-1">
                            <User className="w-3 h-3 text-slate-400" /> KTV Vy
                          </div>
                          <div className="text-[10px] text-slate-400 pl-4">Laser</div>
                        </div>
                        <div className="flex-1 relative h-9 bg-slate-50/40 rounded flex items-center px-1 border border-slate-100">
                          <div
                            onClick={() => handleSelectItem(timelineMockData.truongThao)}
                            className={`left-[25%] w-[12%] ${getCardStyle(
                              't11',
                              'bg-slate-50 border border-dashed border-slate-300',
                              'Clinic'
                            )}`}
                          >
                            <div className="font-bold text-slate-900 truncate text-[10px]">Trương M....</div>
                            <div className="text-[9px] text-slate-500 truncate">K-Renewal...</div>
                          </div>
                          <div
                            onClick={() => handleSelectItem(timelineMockData.lamDuy)}
                            className={`left-[38%] w-[12%] ${getCardStyle(
                              't12',
                              'bg-slate-50 border border-dashed border-slate-300',
                              'Clinic'
                            )}`}
                          >
                            <div className="font-bold text-slate-900 truncate text-[10px]">Lâm T. D...</div>
                            <div className="text-[9px] text-slate-500 truncate">K-Brighten...</div>
                          </div>
                          <div
                            onClick={() => handleSelectItem(timelineMockData.caoNam)}
                            className={`left-[56%] w-[12%] ${getCardStyle('t13', 'bg-emerald-50 border border-emerald-300', 'Clinic')}`}
                          >
                            <div className="font-bold text-slate-900 truncate text-[10px]">Cao V. ...</div>
                            <div className="text-[9px] text-emerald-700 truncate">K-Prime 6/6</div>
                          </div>
                          <div
                            onClick={() => handleSelectItem(timelineMockData.ngoLoc)}
                            className={`left-[69%] w-[12%] ${getCardStyle('t14', 'bg-red-50 border border-red-300', 'Clinic')}`}
                          >
                            <div className="font-bold text-slate-900 truncate text-[10px]">Ngô T. L...</div>
                            <div className="text-[9px] text-red-700 truncate">K-Brighten... 3/6</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* --- GIƯỜNG HỒI TỈNH --- */}
                    <div className="py-2.5">
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-2">
                          <span className="font-bold text-slate-800">Giường hồi tỉnh</span>
                          <span className="bg-purple-100 text-purple-800 px-1.5 py-0.5 rounded text-[9px] font-bold">HẬU PHẪU</span>
                        </div>
                        <div className="flex items-center gap-2 text-slate-400 text-[11px]">
                          <span>Công suất 0%</span>
                          <div className="w-16 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                            <div className="w-[0%] h-full bg-purple-500 rounded-full"></div>
                          </div>
                        </div>
                      </div>

                      {/* Điều dưỡng ca ngày */}
                      <div className="flex items-center py-1 text-[11px] relative">
                        <div className="w-[180px] shrink-0 text-slate-600 pr-2">
                          <div className="font-semibold text-slate-800 flex items-center gap-1">
                            <Users className="w-3 h-3 text-slate-400" /> Điều dưỡng ca ngày
                          </div>
                          <div className="text-[10px] text-slate-400 pl-4">3 giường</div>
                        </div>
                        <div className="flex-1 relative h-9 bg-slate-50/40 rounded flex items-center px-1 border border-slate-100">
                          <div
                            onClick={() => handleSelectItem(timelineMockData.hoiTinhMaiAnh)}
                            className={`left-[40%] w-[22%] ${getCardStyle(
                              't15',
                              'bg-purple-50 border border-purple-300',
                              'Hậu phẫu'
                            )}`}
                          >
                            <div className="font-bold text-slate-900 truncate text-[10px]">Hồi tỉnh – Mai Anh</div>
                            <div className="text-[9px] text-purple-700 truncate">Theo dõi sau mổ - Giường 1</div>
                            <span className="absolute right-1.5 bottom-0.5 text-[9px] text-slate-400 font-medium">5/5</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {/* Legend chú thích */}
          <div className="flex flex-wrap items-center justify-between gap-4 text-[11px] bg-white p-3 rounded-lg border border-slate-200 shadow-2xs">
            <div className="flex items-center flex-wrap gap-3">
              <span className="font-bold text-slate-400 text-[10px] uppercase tracking-wider">TRỤ KD:</span>
              <span className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded-full bg-blue-500 inline-block"></span> Newhair
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded-full bg-emerald-500 inline-block"></span> Clinic
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded-full bg-amber-500 inline-block"></span> PTTM
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded-full bg-purple-500 inline-block"></span> Hậu phẫu
              </span>
            </div>

            <div className="flex items-center flex-wrap gap-3">
              <span className="font-bold text-slate-400 text-[10px] uppercase tracking-wider">TRẠNG THÁI:</span>
              <span className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded bg-slate-300 inline-block"></span> Đã xếp
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded bg-slate-700 inline-block"></span> Đã xác nhận
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded bg-teal-600 inline-block"></span> Check-in
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded bg-blue-600 inline-block"></span> Đang thực hiện
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded bg-emerald-600 inline-block"></span> Hoàn tất
              </span>
            </div>

            <div className="flex items-center flex-wrap gap-3">
              <span className="font-bold text-slate-400 text-[10px] uppercase tracking-wider">Sẵn sàng:</span>
              <span className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded bg-slate-300 inline-block"></span> Đủ
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded bg-slate-700 inline-block"></span> Còn thiếu
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded bg-teal-600 inline-block"></span> Thiếu nhiều
              </span>
            </div>
          </div>
        </div>

        {/* Cột phải: Panel Thông tin chi tiết (Drawer hiển thị khi chọn ca) */}
        {isDrawerOpen && selectedItem && (
          <div className="lg:col-span-3 xl:col-span-2 bg-white p-4 rounded-lg border border-slate-200 shadow-sm space-y-4 relative sticky top-4 animate-in fade-in duration-200">
            <button
              onClick={() => setIsDrawerOpen(false)}
              className="absolute top-3 right-3 text-slate-400 hover:text-slate-600 text-sm font-bold w-6 h-6 flex items-center justify-center rounded-full hover:bg-slate-100 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>

            <div className="pr-6">
              <div className="text-[10px] text-slate-400 font-semibold uppercase tracking-wider flex items-center gap-1">
                <FileText className="w-3 h-3" /> CHI TIẾT CA • {selectedItem.code}
              </div>
              <div className="text-sm font-bold text-slate-900 mt-0.5">{selectedItem.name}</div>
              <div className="text-slate-600 font-medium text-[11px] mt-0.5">{selectedItem.service}</div>
            </div>

            <div className="bg-slate-50 p-2.5 rounded-md border border-slate-100 space-y-1.5">
              <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">HÀNH TRÌNH KHÁCH</div>

              <div className="grid grid-cols-5 gap-1 pt-1">
                <div className="h-1 bg-emerald-600 rounded-full"></div>
                <div className="h-1 bg-emerald-600 rounded-full"></div>
                <div className="h-1 bg-emerald-600 rounded-full"></div>
                <div className="h-1 bg-teal-600 rounded-full"></div>
                <div className="h-1 bg-slate-200 rounded-full"></div>
              </div>

              <div className="grid grid-cols-5 text-[9px] pt-0.5 text-center">
                <span className="text-emerald-600 font-medium">Hẹn</span>
                <span className="text-emerald-600 font-medium">Tiếp đón</span>
                <span className="text-emerald-600 font-medium">Tư vấn</span>
                <span className="font-bold text-blue-600">Xếp ca</span>
                <span className="text-slate-400">Thực hiện</span>
              </div>

              <div className="text-[11px] font-semibold text-slate-800 pt-1">
                Trạng thái: <span className="font-normal text-slate-600">{selectedItem.statusText || selectedItem.status}</span>
              </div>
            </div>

            <div className="space-y-2 text-[11px]">
              <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">THÔNG TIN CA</div>

              <div className="flex justify-between py-1 border-b border-slate-100">
                <span className="text-slate-500">Mã ca</span>
                <span className="font-medium text-slate-800 font-mono">{selectedItem.code}</span>
              </div>
              <div className="flex justify-between py-1 border-b border-slate-100">
                <span className="text-slate-500">Trụ KD</span>
                <span className="font-medium text-slate-800">{selectedItem.channel}</span>
              </div>
              <div className="flex justify-between py-1 border-b border-slate-100">
                <span className="text-slate-500">Khung giờ</span>
                <span className="font-medium text-slate-800 flex items-center gap-1">
                  <Clock className="w-3 h-3 text-slate-400" />
                  {selectedItem.expectedTime}
                </span>
              </div>
              <div className="flex justify-between py-1 border-b border-slate-100">
                <span className="text-slate-500">Trạng thái lịch</span>
                <span className="px-2 py-0.5 bg-slate-100 rounded text-slate-700 font-medium">● {selectedItem.status}</span>
              </div>
              <div className="flex justify-between py-1 border-b border-slate-100">
                <span className="text-slate-500">Nhân sự thực hiện</span>
                <span className="font-medium text-slate-800">{selectedItem.consultant}</span>
              </div>
              <div className="flex justify-between py-1 border-b border-slate-100">
                <span className="text-slate-500">Giá trị ca</span>
                <span className="font-bold text-emerald-600">{selectedItem.price}</span>
              </div>
              <div className="flex justify-between py-1 border-b border-slate-100">
                <span className="text-slate-500">Hạn thực hiện</span>
                <span className="font-medium text-slate-800">{selectedItem.deadline}</span>
              </div>
            </div>

            <div className="p-2.5 bg-amber-50/70 border border-amber-200 rounded-md text-[11px]">
              <div className="font-bold text-amber-900 mb-0.5 flex items-center gap-1">
                <AlertTriangle className="w-3.5 h-3.5 text-amber-600" />
                Tình trạng điều kiện
              </div>
              <div className="text-amber-800">{selectedItem.checklist}</div>
            </div>

            <div className="space-y-2 pt-1">
              <button className="w-full py-2 bg-teal-700 hover:bg-teal-800 text-white font-medium rounded-md shadow-2xs transition-all flex items-center justify-center gap-1.5">
                <Edit3 className="w-3.5 h-3.5" />
                Chỉnh sửa thông tin ca
              </button>
              <button className="w-full py-2 bg-white border border-slate-300 hover:bg-slate-50 text-slate-700 font-medium rounded-md transition-all flex items-center justify-center gap-1.5">
                <RefreshCw className="w-3.5 h-3.5" />
                Đổi lịch / Điều phối lại
              </button>
            </div>
          </div>
        )}
      </div>

      {/* ================= 3. BẢNG RÀNG BUỘC KIỂM TRA & MẮT XÍCH ================= */}
      <div className="bg-white p-4 rounded-md border border-slate-200 shadow-xs space-y-4">
        <div>
          <div className="font-bold text-slate-800 mb-1">RÀNG BUỘC KIỂM TRA KHI XẾP CA</div>
          <div className="text-[11px] text-slate-500 mb-3">Chặn cứng thì không lưu được; cảnh báo thì lưu được nhưng ghi log</div>

          <div className="border border-slate-200 rounded overflow-hidden mb-6">
            <table className="w-full text-left text-[11px]">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-200">
                <tr>
                  <th className="p-2.5 font-semibold">RÀNG BUỘC</th>
                  <th className="p-2.5 font-semibold">MỨC</th>
                  <th className="p-2.5 font-semibold">VÌ SAO</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                <tr>
                  <td className="p-2.5 text-slate-800 font-medium">Trùng phòng / bác sĩ / thành viên ekip</td>
                  <td className="p-2.5">
                    <span className="px-2 py-0.5 bg-red-50 text-red-600 border border-red-200 rounded font-medium">Chặn cứng</span>
                  </td>
                  <td className="p-2.5 text-slate-600">Một người không thể có mặt ở hai ca cùng lúc</td>
                </tr>
                <tr>
                  <td className="p-2.5 text-slate-800 font-medium">Trùng thiết bị dùng chung</td>
                  <td className="p-2.5">
                    <span className="px-2 py-0.5 bg-red-50 text-red-600 border border-red-200 rounded font-medium">Chặn cứng</span>
                  </td>
                  <td className="p-2.5 text-slate-600">Thermage, HIFU, laser dùng chung giữa các phòng</td>
                </tr>
                <tr>
                  <td className="p-2.5 text-slate-800 font-medium">Gây mê toàn thân: cần BS gây mê rảnh + phòng mổ đạt chuẩn</td>
                  <td className="p-2.5">
                    <span className="px-2 py-0.5 bg-red-50 text-red-600 border border-red-200 rounded font-medium">Chặn cứng</span>
                  </td>
                  <td className="p-2.5 text-slate-600">Điều kiện chuyên môn bắt buộc</td>
                </tr>
                <tr>
                  <td className="p-2.5 text-slate-800 font-medium">Buffer setup & vệ sinh: Clinic 15', Newhair/PTTM 30'</td>
                  <td className="p-2.5">
                    <span className="px-2 py-0.5 bg-slate-100 text-slate-600 border border-slate-200 rounded font-medium">Tự chèn</span>
                  </td>
                  <td className="p-2.5 text-slate-600">Hệ thống tự cộng, không cần điều phối nhớ</td>
                </tr>
                <tr>
                  <td className="p-2.5 text-slate-800 font-medium">Giường hồi tỉnh còn trống sau ca</td>
                  <td className="p-2.5">
                    <span className="px-2 py-0.5 bg-amber-50 text-amber-700 border border-amber-200 rounded font-medium">Chặn xác nhận</span>
                  </td>
                  <td className="p-2.5 text-slate-600">Xếp được ca nhưng không xác nhận được cho tới khi có giường</td>
                </tr>
                <tr>
                  <td className="p-2.5 text-slate-800 font-medium">Consent / xét nghiệm tiền phẫu chưa đủ</td>
                  <td className="p-2.5">
                    <span className="px-2 py-0.5 bg-amber-50 text-amber-700 border border-amber-200 rounded font-medium">Chặn xác nhận</span>
                  </td>
                  <td className="p-2.5 text-slate-600">Áp dụng cho PTTM và Newhair</td>
                </tr>
                <tr>
                  <td className="p-2.5 text-slate-800 font-medium">Chưa đủ cọc theo chính sách</td>
                  <td className="p-2.5">
                    <span className="px-2 py-0.5 bg-sky-50 text-sky-700 border border-sky-200 rounded font-medium">Cảnh báo</span>
                  </td>
                  <td className="p-2.5 text-slate-600">Hiện số cọc thiếu ngay trên thẻ ca</td>
                </tr>
                <tr>
                  <td className="p-2.5 text-slate-800 font-medium">Ca vượt giờ vận hành 08:00 – 19:00</td>
                  <td className="p-2.5">
                    <span className="px-2 py-0.5 bg-sky-50 text-sky-700 border border-sky-200 rounded font-medium">Cảnh báo</span>
                  </td>
                  <td className="p-2.5 text-slate-600">Cho override nhưng ghi log người duyệt</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-md border border-slate-200 shadow-xs space-y-4">
        {/* Phần Mắt xích với các màn trước và sau */}
        <div className="font-bold text-slate-800 mb-2">MẮT XÍCH VỚI CÁC MÀN TRƯỚC VÀ SAU</div>
        <div className="border border-slate-200 rounded overflow-hidden">
          <table className="w-full text-left text-[11px]">
            <thead className="bg-slate-50 text-slate-500 border-b border-slate-200">
              <tr>
                <th className="p-2.5 font-semibold">MÀN</th>
                <th className="p-2.5 font-semibold">DỮ LIỆU BÀN GIAO</th>
                <th className="p-2.5 font-semibold">ĐIỀU KIỆN CHUYỂN</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              <tr>
                <td className="p-2.5 text-slate-800 font-medium">Lịch hẹn</td>
                <td className="p-2.5 text-slate-600">Khách, kênh, nhu cầu, nhân sự phụ trách</td>
                <td className="p-2.5 text-slate-600">Khách xác nhận đến</td>
              </tr>
              <tr>
                <td className="p-2.5 text-slate-800 font-medium">Tiếp đón</td>
                <td className="p-2.5 text-slate-600">Giờ check-in thật, số thứ tự, khu vực chờ</td>
                <td className="p-2.5 text-slate-600">Khách có mặt tại cơ sở</td>
              </tr>
              <tr>
                <td className="p-2.5 text-slate-800 font-medium">Lịch tư vấn</td>
                <td className="p-2.5 text-slate-600">Chỉ định dịch vụ, cọc, hồ sơ, hạn thực hiện</td>
                <td className="p-2.5 text-slate-600">Tư vấn chốt ca</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}